import { isApiName } from 'self-service-api/core/type-guards/apiName';
import { useGetAddOnsQuery } from '../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc.hooks';
import { useAppSelector } from '../reducers';
import { getAddOnsFromApiNamesWithTranslations } from '../utils/addOnsUtils';
import { useGlobalLoading } from './loadingHooks';
export const useAllEligibleAddOnsWithTranslations = ({
  searchTerm = ''
} = {}) => {
  const isAppReady = useGlobalLoading();
  const {
    data: addOnsData,
    loading: addOnsLoading
  } = useGetAddOnsQuery();
  const eligibleAddOnApiNames = addOnsData === null || addOnsData === void 0 ? void 0 : addOnsData.eligibleAddOns.filter(isApiName);
  const {
    filteredAddOns,
    totalAddOns
  } = useAppSelector(state => {
    if (!isAppReady) {
      return {
        filteredAddOns: [],
        totalAddOns: 0
      };
    }
    return getAddOnsFromApiNamesWithTranslations(state, eligibleAddOnApiNames || [], searchTerm);
  });
  return {
    addOns: filteredAddOns,
    totalAddOns,
    loading: !isAppReady || addOnsLoading,
    loaded: isAppReady && !addOnsLoading
  };
};